import { IObjectMap, ISectionLayoutItem } from 'shared-types/SharedTypes';
import { IDiaryService } from 'shared-types/DiaryTypes';

export const getLayoutBySectionLookup = (services: IDiaryService[], currentTime: Date) => {
  // have to ask jim - why we filtering sections based on current service -
  // const filteredService = services.filter((service) => {
  //   return currentTime.getTime() > service.startTime.getTime() && currentTime.getTime() < service.endTime.getTime();
  // });
  const sectionLayouts: ISectionLayoutItem[] = services.reduce((acc, service) => {
    service.sectionLayouts.forEach((sectionLayout) => {
      if (!sectionLayout.sectionClosed && !sectionLayout.sectionNotUsed) {
        acc.push(sectionLayout);
      }
    })
    return acc;
  }, []);
  const sectionIdToLayoutIds = sectionLayouts.reduce((acc: IObjectMap<string>, curr) => {
    if (!acc[curr.sectionId]) {
      acc[curr.sectionId] = [];
    }
    if (!acc[curr.sectionId].includes(curr.layoutId)) {
      acc[curr.sectionId].push(curr.layoutId);
    }
    return acc;
  }, {});
  return sectionIdToLayoutIds;
}
